/**
 * Query keys del dominio Notificaciones.
 *
 * Keys consistentes y serializables (`docs/frontend_conventions.md`, Datos). Las
 * notificaciones se filtran por la sede activa (el backend lo hace vía `X-Sede-Id`),
 * así que la key incluye la sede para **cachear por sede**: al cambiar de sede, la
 * campana se recarga (clave distinta) en vez de mostrar las de la sede anterior.
 */

/** Raíz de las queries de notificaciones (para invalidación amplia). */
export const NOTIFICATIONS_ROOT_KEY = ["notifications"] as const;

/** Key de las notificaciones no vistas, segmentada por sede activa. */
export function notificationsQueryKey(sedeId: number | null) {
  return ["notifications", { sede: sedeId }] as const;
}
